module.exports = __webpack_public_path__ + "static/media/logo2.a891a93b.png";